import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">常见问题</h2>
          <p className="text-sm text-foreground-500">关于吃瓜视频，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <details key={item.q} className="group rounded-xl bg-background-50 border border-background-200 overflow-hidden cursor-pointer" open>
              <summary className="flex items-center justify-between p-5 text-sm md:text-base font-medium text-foreground-900 list-none">
                <span className="flex items-center gap-3">
                  <span className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-question-line text-accent-600 text-sm"></i>
                  </span>
                  {item.q}
                </span>
                <i className="ri-arrow-up-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0 ml-3"></i>
              </summary>
              <div className="px-5 pb-5 pl-[68px]">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}